import type { DealForwardData } from '@src/types/OTC';
import { InlineFormattedNumber, useCurrenciesContext } from '@talos/kyoko';

interface PriceDisplayProps {
  instrumentData: DealForwardData;
}

export const ForwardPriceDisplay = ({ instrumentData }: PriceDisplayProps) => {
  const value = instrumentData.DealInfo.ForwardPrice || '';
  const currency = instrumentData.DealInfo.forwardPriceCurrency;
  const { currenciesBySymbol } = useCurrenciesContext();
  const currencyInfo = currency ? currenciesBySymbol.get(currency) : undefined;
  return (
    <InlineFormattedNumber
      data-testid="instrument-inspector-section-field-value"
      number={value}
      currency={currencyInfo?.Symbol ?? currency}
      increment={currencyInfo?.DefaultIncrement}
      background="backgroundBlotterTableRowHover"
      showDashIfEmpty
    />
  );
};
